module.exports = __webpack_public_path__ + "img/119.ac38a323.jpg";